import {
    ReactNode,
} from 'react'
import {
    WarningCardVariant,
} from 'app/enums/common.enums'
import useStyles from './WarningCard.styles'

const WARNING_ICON_PATH = 'assets/images/warning_orange.svg'
const ERROR_ICON_PATH = 'assets/images/warning.svg'

const iconMap = {
    [WarningCardVariant.Warning]: WARNING_ICON_PATH,
    [WarningCardVariant.Error]: ERROR_ICON_PATH,
    [WarningCardVariant.Critical]: ERROR_ICON_PATH,
}

const WarningCard = ({
    children,
    variant = WarningCardVariant.Error,
}: Readonly<{
    children: ReactNode | ReactNode[];
    variant?: WarningCardVariant
}>) => {
    const {
        cx,
        classes,
    } = useStyles()

    return (
        <div
            className={cx(classes.container, classes[variant])}
            data-testid="caution-message"
        >
            <img
                src={iconMap[variant]}
                alt="warning"
            />
            <div className={classes.text}>
                {children}
            </div>
        </div>
    )
}

export default WarningCard
